
























































import { Vue, Component } from 'vue-property-decorator'
import HeaderBar from '@/components/header-bar/index.vue'
import { formatSeconds } from '@/utils/formator.ts'
import * as broadcastService from '@/services/broadcast'
import { checkStatusMap } from '@/constants/statusMap'

interface CurType {
  id?: number
}

@Component({ components: { HeaderBar } })
export default class BroaCastManage extends Vue {
  checkStatusMap = checkStatusMap
  delData: Array<object> = []
  listData: Array<any> = []
  isDel = false
  $toast: any
  tabCur = 0

  get userInfoInapp() {
    return this.$store.state.userInfoInapp
  }

  created() {
    this.fetchVideosByPlid()
  }

  delAction(vid: number) {
    if (this.listData.length > 0) {
      const index: number = this.listData.findIndex(
        (item: any) => item.id === vid
      )
      this.delData.push({
        plId: this.listData[index].plId,
        videoId: this.listData[index].videoId,
      })
      this.listData.splice(index, 1)
      this.isDel = true
    }
  }

  upData() {
    this.tabCur = 0
    this.listData.sort(function(a, b) {
      return b.sortNo - a.sortNo
    })
  }

  downData() {
    this.tabCur = 1
    this.listData.sort(function(a, b) {
      return a.sortNo - b.sortNo
    })
  }

  async submit() {
    const res = await broadcastService.delPlayVideos(this.delData)

    if (res) {
      this.$toast(res.msg)
    }
  }

  async fetchVideosByPlid() {
    const data = await broadcastService.getVideosByPlid(
      parseInt(this.$route.params.id)
    )
    if (data && data.code == 200) {
      this.listData = data.data
    }
  }

  formatSeconds(val = 0) {
    return formatSeconds(val)
  }
}
